import { appLocalStorage } from '../../../utils/storage';
import { BackIcon, SendIcon } from '../../../components/Brand/Icon';
import '../../../components/Buttons/index.scss';
import './StoryAdd.scss';
import React, { useState, useRef, useEffect } from "react";
import { Layout, Input } from 'antd';
import message from '../../../components/Brand/brandMessage';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import url from '../../../utils/url';
import config from '../../../utils/config';
import api from '../../../services';
import { APP_ROUTES } from '../../../utils/constant';
import BrandLoader from '../../../components/Brand/BrandLoader';
import ContentLimitStatus from '../../../components/Brand/ContentLimitStatus';
import { measureTitle, contentLimitMessage } from '../../../utils/contentLimits';
import { accountProtectionMessage } from '../../../accountProtection/feedback';
import { getUser } from '../../../utils/func';

const { TextArea } = Input;
const { storyAdd } = api;

export default function StoryAdd() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const [storyTitle, setStoryTitle] = useState(() => {
		const recovered = location.state?.protectionDraft;
		return recovered?.userId === getUser()?.id && typeof recovered?.title === 'string'
			? recovered.title : new URLSearchParams(location.search).get('title') || '';
	});
	const [loading, setLoading] = useState(false);
	const titleMeasurement = measureTitle(storyTitle);

	const mounted = useRef(false);
	const pending = useRef(false);

	useEffect(() => {
		mounted.current = true;
		return () => { mounted.current = false; };
	}, []);

	const onChangeTitle = (e) => {
		setStoryTitle(e.target.value);
	}

	const onBack = () => {
		navigate(-1)
	}

	const sendStory = async () => {
		if (pending.current || !storyTitle.trim()) return;
		const limitMessage = contentLimitMessage(measureTitle(storyTitle).error, t);
		if (limitMessage) { message.open({ type: 'error', content: limitMessage }); return; }
		pending.current = true;
		setLoading(true);
		let leaving = false;
		try {
			const privat_flg = appLocalStorage.getItem(config.privat) === 'true';
			const response = await storyAdd({ title: storyTitle, privat: privat_flg });
			if (!mounted.current) return;
			if (response.statusCode === 401) {
				leaving = true;
				navigate(url(APP_ROUTES.LOGIN + '?from=' + encodeURIComponent(window.location.pathname + '?title=' + encodeURIComponent(storyTitle))), { replace: true });
				return;
			}
			if (!response.success || Object.prototype.hasOwnProperty.call(response, 'error')) {
				message.open({ type: 'error', content: accountProtectionMessage(response, t)
					|| contentLimitMessage(response.errorCode || response.message, t) || t('story.add_error') });
				return;
			}
			message.open({ type: 'success', content: t(response.new ? 'story.new_story_add' : 'story.new_story_merge') });
			leaving = true;
			navigate(url(APP_ROUTES.REACTION + '/' + response.id));
		} catch (error) {
			if (mounted.current) message.open({ type: 'error', content: t('story.add_error') });
		} finally {
			// Keep the submission locked until navigation unmounts this page.
			if (mounted.current && !leaving) {
				pending.current = false;
				setLoading(false);
			}
		}
	}

	return (
		<Layout className="app-safe-layout story-add-page">
			<Helmet>
				<title>{t('story.add')}</title>
				<meta name="description" content={t('story.add')} />
			</Helmet>
			{
				loading &&
				<BrandLoader className="story-add-loading" label={t('story.find_news')} />
			}
			<div className="story_add_wrap">
				<TextArea autoFocus disabled={loading} aria-invalid={Boolean(titleMeasurement.error)} aria-label={t('story.title_placeholder')} className="story_add_text" value={storyTitle} placeholder={t('story.title_placeholder')} onChange={onChangeTitle} />
			</div>
			<ContentLimitStatus measurement={titleMeasurement} kind="title" />
			<div className="control-panel-editor footer-button footer-button--main story-add-actions">
				<button type="button" className="wiw-icon-button"
					aria-label={t('common.back', { defaultValue: 'Back' })}
					onClick={onBack}
				><BackIcon className="nav-icon" /></button>
				<button type="button" className="wiw-icon-button"
					aria-label={t('story.add')}
					disabled={loading || !storyTitle.trim() || Boolean(titleMeasurement.error)}
					onClick={sendStory}
				><SendIcon className="nav-icon" /></button>
			</div>
		</Layout>
	)
}
